import { useEffect } from 'react';

type Props = {
  show: boolean;
  delta: 1 | -1;
  onDone: () => void;
  durationMs?: number;
};

export function FamUpToast({ show, delta, onDone, durationMs = 900 }: Props): JSX.Element | null {
  useEffect(() => {
    if (!show) return;
    const t = window.setTimeout(onDone, durationMs);
    return () => clearTimeout(t);
  }, [show, durationMs, onDone]);

  if (!show) return null;
  return (
    <div
      className="fixed top-[max(72px,env(safe-area-inset-top))] left-1/2 -translate-x-1/2 z-40 pointer-events-none animate-fam-up-toast"
      aria-hidden
    >
      <div className="bg-surface border border-border rounded-full px-4 py-1.5 text-primary text-hint">
        {delta > 0 ? '+1' : '−1'}
      </div>
    </div>
  );
}
